<template>
    <div class="print-text" v-if="seen">
        <img :src=path ref="img" />
    </div>
</template>
<style scoped>
    .print-text {
        text-align: left;
        padding: 2em 3em;
    }
</style>

<script>
import { setTimeout } from 'timers'
import cookies from '@/services/cookies'
export default {
    data() {
        return {
            seen: false,
            path: ''
        }
    },
    mounted() {
        this.seen = true

        this.$route.params.file
        
        let data = {
            id: this.$route.params.file,
            token: cookies.getCookie('token')
        }

        let that = this

        this.$socket.emit('loadimage', data, function(data) {
            if(data.data === true) {
                if(data.found === 1) {
                    that.path = data.img  
                    setTimeout(function() {
                        window.print()
                    }, 1000)
                }
            } else {
                that.$router.push('/login')
            }
        })
    }
}
</script>
